import React from 'react';

import cx from 'classnames';

// components
import AboutAndHelp from './AboutAndHelp';
import MobileApps from './MobileApps';
import SocialAndTerms from './SocialAndTerms';
import HomeStoreLinks from './StoreLinks';

// styles
import './Footer.css';

const HomeStoreFooter = () => {
  return (
    <footer className={cx('zola-ui', 'common-footer', 'home-store', 'common-footer--logo-rebrand')}>
      <div className="common-footer__container">
        <div className="common-footer__desktop">
          <HomeStoreLinks />
        </div>
        <div className="common-footer__mobile">
          <HomeStoreLinks />
        </div>
      </div>
    </footer>
  );
};

type FooterProps = {
  isWebStore?: boolean;
};

const Footer = ({ isWebStore = false }: FooterProps): JSX.Element => {
  if (isWebStore) {
    return <HomeStoreFooter />;
  }

  return (
    <footer className={cx('zola-ui', 'common-footer', 'common-footer--logo-rebrand')}>
      <div className="common-footer__container">
        <div className="common-footer__desktop">
          <SocialAndTerms />
          <AboutAndHelp />
          <MobileApps />
        </div>
        <div className="common-footer__mobile">
          <MobileApps />
          <AboutAndHelp />
          <SocialAndTerms />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
